import { ComponentFactoryResolver, ComponentRef, Directive, ElementRef, Input, OnDestroy, OnInit, Optional, Renderer2, ViewContainerRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EMPTY, fromEvent, merge, Observable } from 'rxjs';
import { ControlErrorContainerDirective } from './control-error-container.directive';
import { FormSubmitDirective } from './form-submit.directive';
import { ValidationErrorTranslations } from './validation-errors-translations.service';
import { ValidationMessageComponent } from './validation-message.component';

/**
 * Directive for handling control errors
 */
@UntilDestroy()
@Directive({
  selector: '[formControl], [formControlName]'
})
export class ControlErrorsDirective implements OnInit, OnDestroy {
  public submit$: Observable<Event>;
  public ref: ComponentRef<ValidationMessageComponent>;
  public container: ViewContainerRef;
  /* public isFocused: boolean; */
  @Input() public customErrors: any = {};

  constructor(
    public resolver: ComponentFactoryResolver,
    public vcr: ViewContainerRef,
    private controlDir: NgControl,
    private el: ElementRef,
    private renderer: Renderer2,
    @Optional() private form: FormSubmitDirective,
    @Optional() controlErrorContainer: ControlErrorContainerDirective,
    private errors: ValidationErrorTranslations
  ) {
    this.submit$ = this.form ? this.form.submit$ : EMPTY;
    this.container = controlErrorContainer ? controlErrorContainer.vcr : vcr;
  }

  public ngOnInit(): void {
    const touched$ = fromEvent(this.el.nativeElement, 'blur');
    const parent = this.renderer.parentNode(this.container.element.nativeElement);
    merge(this.submit$, touched$, this.control.statusChanges)
    .pipe(untilDestroyed(this))
    .subscribe(v => {
      const controlErrors = this.control.errors;
      if (controlErrors) {
        this.renderer.addClass(parent, 'esf-form-validation--alert');
        const firstKey = Object.keys(controlErrors)[0];
        const getError = this.errors[firstKey];
        const text = this.customErrors[firstKey] || getError(controlErrors[firstKey]);
        this.setError(text);
      } else if (this.ref) {
        this.setError(null);
        this.renderer.removeClass(parent, 'esf-form-validation--alert');
      }

      /* if (this.isFocused) {
        this.setError(null);
      } */
    });
  }

  public get control(): any {
    return this.controlDir.control;
  }

  /**
   * Sets the current error in text
   */
  public setError(text: string): void {
    if (!this.ref) {
      const factory = this.resolver.resolveComponentFactory(ValidationMessageComponent);
      this.ref = this.container.createComponent(factory);
    }
    this.ref.instance.text = text;
  }

  /* eslint-disable-next-line , , , , , ,  */

  public ngOnDestroy(): void { }

}
